import { createWebHistory, createRouter } from "vue-router";
import { useGlobalStore } from "@stores/global";
import { useGlobeStore } from "@stores/globe";

/* Layouts */
import App from "@layouts/App.vue";

/* Pages */
import Explore from "@pages/Explore.vue";
import Trivia from "@pages/Trivia.vue";
import Achievements from "@pages/Achievements.vue";
import Vote from "@pages/Vote.vue";
import Settings from "@pages/Settings.vue";
// import MeetSpeed from "@pages/MeetSpeed.vue";
import About from "@pages/About.vue";
import Rules from "@pages/Rules.vue";
import Activities from "@pages/Activities.vue";

/* Routes */
const routes = [
    {
        path: "/",
        component: App,
        children: [
            { path: "", name: "landing", component: { render: () => null } },
            { path: "explore", name: "explore", component: Explore },
            { path: "trivia", name: "trivia", component: Trivia },
            {
                path: "achievements",
                name: "achievements",
                component: Achievements,
            },
            { path: "vote", name: "vote", component: Vote },
            { path: "settings", name: "settings", component: Settings },
            // { path: "meet-speed", name: "help", component: MeetSpeed },
            { path: "activities", name: "activities", component: Activities },
            { path: "about", name: "about", component: About },
            {
                path: "rules/:lang(en|es|fr)",
                name: "rules",
                component: Rules,
            },
            {
                path: "rules",
                redirect: { name: "rules", params: { lang: "en" } },
            },
            {
                path: "/:catchAll(.*)",
                name: "404",
                redirect: { name: "landing" },
            },
        ],
    },
];

const router = createRouter({
    scrollBehavior(to, from, savedPosition) {
        if (to.name === from.name && !to.hash) {
            return { top: 0, behavior: "smooth" };
        } else if (to.hash) {
            return {
                el: to.hash,
                top: 100,
                behavior: "smooth",
            };
        } else {
            return {
                top: 0,
            };
        }
    },
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from) => {
    const global = useGlobalStore();
    const isPageRoute = to.name && to.name !== "landing" && to.name !== "404";

    if (isPageRoute && global.mode === "landing") {
        if (global.globeReady) {
            global.mode = "playing";
            return true;
        } else {
            global.pendingRoute = to.name;
            return { name: "landing" };
        }
    } else if (to.name === "landing" && global.mode === "playing") {
        if (from.name === "explore") {
            const globe = useGlobeStore();
            if (globe.selectedCountry) {
                globe.clearSelection();
                globe.clearHover();
                global.hidePanel("countryInfo");
                global.hidePanel("clips");
                return false;
            }
        }
        global.mode = "landing";
    }
});

export default router;
